import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import moment from "moment";
import { withRouter } from "react-router-dom";
import getPictureUrl from "../../../../lib/getPictureUrl";
import NewsDetailPopup from "../../../../components/Users/Profile/components/NewDetailPopup";

const News = ({ news, onCloseSection, history, location }) => {
  const [moreContent, setMoreContent] = useState(null);

  const [selectedNew, setSelectedNew] = useState(null);

  useEffect(() => {
    if (news && location.hash) {
      const newId = location.hash.replace("#", "");
      if (newId) {
        const newData = (news.news || []).find(
          item => item.id === parseInt(newId)
        );
        if (newData) {
          const body = document.body;
          body.classList.add("body-overflow");
          setSelectedNew(newData);
        } else {
          handleClosePopup();
        }
      }
    } else {
      setSelectedNew(null);
    }
  }, [location.hash, news]);
  const handleReadMore = newId => {
    if (newId === moreContent) {
      setMoreContent(null);
    } else {
      setMoreContent(newId);
    }
  };

  const newsData = (news && news.news) || [];
  const totalNews = (news && news.totalNews) || 0;
  const handleNewDetail = item => {
    const { pathname, search } = location;
    history.push({
      pathname,
      search,
      hash: `${item.id}`
    });
  };
  const handleClosePopup = () => {
    const { pathname, search } = location;
    setSelectedNew(null);
    const body = document.body;
    body.classList.remove("body-overflow");
    history.push({
      pathname,
      search,
      hash: ""
    });
  };
  return (
    <div>
      <Helmet>
        <title>News</title>
        <meta property="og:title" content="News" />
      </Helmet>
      <div className="profile-desktop">
        {/* Header */}
        <div className="head-general with-back">
          <a
            onClick={() => onCloseSection("newsSection")}
            className="back cursor-pointer"
          >
            <img src="/png/chevron-left.png" />
          </a>
          <h4>What{"'"}s New?</h4>
          <a onClick={() => onCloseSection("newsSection")} className="close">
            <i className="icon icon-close cursor-pointer" />
          </a>
        </div>
        {/* Header */}
        <h4 className="hide-xs general-title">What{"'"}s New?</h4>
      </div>
      {/* .profile-desktop */}
      <div className="what-news-page white-bg">
        {selectedNew ? (
          <NewsDetailPopup
            newItem={selectedNew}
            handleClosePopup={handleClosePopup}
          />
        ) : null}
        {newsData.map(newItem => {
          const matched = moreContent === newItem.id;
          const pictures = [{ url: newItem.image }];
          return (
            <React.Fragment key={newItem.id}>
              <div
                className="accordion-tab white-bg"
                onClick={() => handleNewDetail(newItem)}
              >
                <div className="item">
                  <div className="item accordion-button">
                    {newItem.image && (
                      <div className={`img ${(newItem.isRead && "") || "new"}`}>
                        {!newItem.isRead && <span className="badge">New</span>}

                        <img
                          align="left"
                          src={getPictureUrl(pictures, 600, 0)}
                        />
                      </div>
                    )}

                    {(newItem.image && (
                      <>
                        <div>
                          <h4>{newItem.title}</h4>
                          {!newItem.isRead && !newItem.image ? (
                            <span className="badge">New</span>
                          ) : (
                            <noscript />
                          )}

                          <div className="desc">
                            {(newItem.content &&
                              newItem.content.length > 350 && (
                                <p>
                                  {newItem.content.slice(0, 350)}{" "}
                                  {(matched && <noscript />) || (
                                    <span>...</span>
                                  )}
                                </p>
                              )) || <p>{newItem.content}</p>}
                          </div>
                        </div>
                        <div
                          className={
                            "body accordion-panel" +
                            ((matched && "-active") || "")
                          }
                        >
                          {matched && <p>{newItem.content.slice(-350)}</p>}
                        </div>
                      </>
                    )) || (
                      <>
                        {" "}
                        <div>
                          <h4>{newItem.title}</h4>
                          {!newItem.isRead && !newItem.image ? (
                            <span className="badge">New</span>
                          ) : (
                            <noscript />
                          )}
                          {!matched && (
                            <div className="desc">
                              {(newItem.content &&
                                newItem.content.length > 350 && (
                                  <p>
                                    {newItem.content.slice(0, 350)}{" "}
                                    {(matched && <noscript />) || (
                                      <span>...</span>
                                    )}
                                  </p>
                                )) || <p>{newItem.content}</p>}
                            </div>
                          )}
                        </div>
                        <div
                          className={
                            "body accordion-panel" +
                            ((matched && "-active") || "")
                          }
                        >
                          {matched && <p>{newItem.content}</p>}
                        </div>
                      </>
                    )}

                    <div className="foot d-flex align-items-center justify-content-between">
                      <a onClick={() => handleReadMore(newItem.id)}>
                        {(newItem.content.length > 350 &&
                          ((matched && "Show less") || "Show more")) || (
                          <noscript />
                        )}
                      </a>
                      <p>{moment(newItem.createdAt).format("DD-MM-YYYY")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
        {newsData.length > totalNews && (
          <div className="button">
            <button className="btn btn-blue">Load More</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(News);
